import {columns} from "@/features/types/AutoTableInterface";

export type Option = { value: string; label: string };
export type GroupedOptions = {
    label: string;
    options: Option[];
}[];

export type columnTypes = 'input' | 'numberInput' | 'select' | 'date' | 'boolean';
export const numberInputOptions: Option[] = [
    {value: '>', label: '>'},
    {value: '<', label: '<'},
    {value: '=', label: '='},
    {value: '!=', label: '!='},
];

export const nullableOptions: Option[] = [
    {value: "PUSTE", label: "JEST PUSTE"},
    {value: "NIEPUSTE", label: "NIE JEST PUSTE"},
];

export type FilterKey = typeof columns[number] extends { type: columnTypes; accessorKey: infer K } ? K : never;
export type Filters = {
    [K in FilterKey]?: string;
}